import { useSelector } from 'react-redux';
import { Params, useParams } from 'react-router';
import { selectConnectedCrmOrgs } from '../components/pages/environments/environmentsReducer';
import { extractShortUUID } from './readableUUID';

export const useSweepParams = <
  ParamsOrKey extends string | Record<string, string | undefined> = string,
>(): Readonly<[ParamsOrKey] extends [string] ? Params<ParamsOrKey> : Partial<ParamsOrKey>> => {
  const params = useParams<ParamsOrKey>();
  const crmOrgId = (params as any).crmOrgId;
  const crmOrgs = useSelector(selectConnectedCrmOrgs);
  if (crmOrgId && crmOrgId.length !== 36) {
    const shortCrmOrgId = extractShortUUID(crmOrgId);
    if (shortCrmOrgId) {
      const crmOrg = crmOrgs.find((crmOrg) => crmOrg.id.startsWith(shortCrmOrgId));
      if (crmOrg) {
        return {
          ...params,
          crmOrgId: crmOrg.id,
        };
      } else {
        throw new Error('Invalid crmOrgId');
      }
    }
  }
  return params;
};
